import { IAppState } from '../../redux';

export const selectInputAddress = (state: IAppState): string => {
  return state.offer.geo?.userInput || '';
};
